/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolWaterDropIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-water-drop"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M12 22.9Q12 22.9 10.13 22.9Q8.25 22.9 5.75 20.34Q3.25 17.77 3.25 13.9Q3.25 12.25 3.99 10.57Q4.72 8.9 5.83 7.36Q6.92 5.83 8.24 4.5Q9.55 3.17 10.7 2.17Q10.97 1.93 11.31 1.81Q11.65 1.7 12 1.7Q12.35 1.7 12.69 1.81Q13.03 1.93 13.3 2.17Q14.45 3.17 15.76 4.5Q17.07 5.83 18.18 7.36Q19.27 8.9 20.01 10.57Q20.75 12.25 20.75 13.9Q20.75 17.77 18.25 20.34Q15.75 22.9 12 22.9ZM12.28 19Q12.63 18.98 12.86 18.74Q13.1 18.5 13.1 18.18Q13.1 17.82 12.84 17.57Q12.57 17.32 12.2 17.35Q11.18 17.43 10.1 16.86Q9.03 16.3 8.72 14.63Q8.68 14.3 8.43 14.11Q8.18 13.93 7.9 13.93Q7.5 13.93 7.26 14.21Q7.03 14.5 7.1 14.88Q7.53 17.15 9.1 18.13Q10.68 19.1 12.28 19Z" fill={color} />
    </svg>
  );
}
